// extracted by mini-css-extract-plugin
export default {"stackOnMobile":"useStackOnMobile_stackOnMobile__HuK5K"};